import React, {useEffect, useState} from "react";
import {Flex, message, Spin} from "antd";
import {RcFile, UploadChangeParam} from "antd/es/upload";
import styles from "./UploadAvatar.module.scss";
import { ReactComponent as EditIcon } from "../../../../../../assets/images/global-icons/pencil_ic.svg";
import { ReactComponent as PersonIcon } from "../../../../../../assets/images/global-icons/persone_ic.svg";
import UploadAvatarModal from "./components/UploadAvatarModal/UploadAvatarModal";
import {useUploadAvatarMutation} from "../../../../../../redux/API/fileSlice";
const BASE_FILE_URL = process.env.REACT_APP_FILES_BASE_URL || ''


interface UploadAvatarProps {
  setAvatar: Function,
  avatar?: string,
}

const UploadAvatar = ({setAvatar, avatar}: UploadAvatarProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileStatus, setFileStatus] = useState({});
  const [avatarKey, setAvatarKey] = useState('');
  const [uploadFile, {isLoading}] = useUploadAvatarMutation();

  useEffect(() => {
    if (avatar)
      setAvatarKey(avatar)
  }, [avatar]);

  const handleAvatarUpload = (file: RcFile) => {
    const isValidFormat = ["image/png", "image/jpeg", "image/heic"].includes(file.type);
    if (!isValidFormat) {
      message.error("Only PNG, JPG, and HEIC files are allowed!");
    }
    return isValidFormat;
  };

  const handleChange = async (info: UploadChangeParam) => {
    const { file, fileList } = info;
    setIsModalOpen(false);

    const fileObj = fileList.find((item) => item.uid === file.uid)?.originFileObj;

    if (fileObj) {
      setFileStatus({
        name: file.name,
        size: file.size,
        type: file.type,
        uid: file.uid,
        status: 'pending'
      });

      try {
        const result = await uploadFile(fileObj).unwrap();
        console.log(result)
        if (result?.success) {
          setTimeout(
            () => {
              setFileStatus({
                name: file.name,
                size: file.size,
                type: file.type,
                id: result?.data?.avatarKey,
                uid: file?.uid,
                status: 'success'
              });
            },
            Math.random() * 1000
          );
          setAvatar(result?.data?.avatarKey);
          setAvatarKey(result?.data?.avatarKey);
          setIsModalOpen(false);
        } else {
          throw new Error('Upload failed');
        }
      } catch (err) {
        setTimeout(
          () =>
            setFileStatus((prev) => ({
              name: file.name,
              size: file.size,
              type: file.type,
              uid: file.uid,
              status: 'denied'
            })),
          Math.random() * 1000
        );
        console.log(err)
      }
    }
  };

  return (
    <Flex className={styles.avatarUpload}>
      <div
        className={styles.avatarUpload__wrapper}
        onClick={() => !isLoading && setIsModalOpen(true)}
      >
        {avatarKey ? (
          <img src={`${BASE_FILE_URL}/${avatarKey}`} alt="Avatar" className={styles.avatarUpload__image} />
        ) : (
          <PersonIcon />
        )}
        <div className={styles.avatarUpload__wrapper__edit}>
          <EditIcon className={styles.avatarUpload__wrapper__edit__icon} />
        </div>

        {isLoading && (
          <div className={styles.avatarUpload__overlay}>
            <Spin size="large" />
          </div>
        )}
      </div>

      <UploadAvatarModal
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onUpload={handleAvatarUpload}
        onChange={handleChange}
      />
    </Flex>
  );
};

export default UploadAvatar;
